/**
 *
 * @category Enums
 * @export
 * @enum {number}
 */
export var EBoundingType;
(function (EBoundingType) {
    /**
     * Relative to the real bounding of the shape
     * @order 2
     */
    EBoundingType[EBoundingType["Relative"] = 1] = "Relative";
    /**
     * Fixed to te width and height of the shape
     * @order 3
     */
    EBoundingType[EBoundingType["Fixed"] = 2] = "Fixed";
})(EBoundingType || (EBoundingType = {}));
//# sourceMappingURL=shape-base.js.map